export const LINE_THICKNESS_OPTIONS = Array.from(
  { length: 10 },
  (_, i) => i + 1
);

export const LINE_STYLES = [
  { value: 'solid', label: 'Solid', icon: 'polygon_line_tool' },
  { value: 'dashed', label: 'Dashed', icon: 'polygon_line_tool' },
  { value: 'dotted', label: 'Dotted', icon: 'polygon_line_tool' },
] as const;
